export enum ValidationStatus {
    Validating,
    Validated,
    Failed
}
